import { useMemo } from 'react'
import { useRenewalsList } from '@omnea-app/fe-renewals/useRenewalsList'

export const useRenewalCount = () => {
  const { data: renewalListResponse } = useRenewalsList()
  const renewals = useMemo(() => renewalListResponse || [], [renewalListResponse])

  const inProgressRenewals = useMemo(
    () =>
      renewals?.filter((renewal) => {
        const inProgress = renewal.requestId ?? false
        if (!inProgress) return false
        const isComplete = renewal.computedFields.status.type === 'complete'
        const isRejected = renewal.computedFields.status.type === 'rejected'
        return !isComplete && !isRejected
      }) || [],
    [renewals]
  )

  const inProgressRenewalsCount = inProgressRenewals.length

  return inProgressRenewalsCount
}
